import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { RevenueMonthlyResponseSchema } from "../response/RevenueMonthlyResponse";

const API_VERSION = 'v3';

interface FilterProps {
    property_id: string;
    start_date: string;
    end_date: string;
}

interface RevenueMonthlyProps {
    filter?: FilterProps;
}

const useRevenueMonthly = (params: RevenueMonthlyProps) => {
    return useQuery({
        queryKey: [
            'report',
            'revenue-monthly',
            JSON.stringify(params.filter) // Pastikan filter bisa digunakan sebagai key
        ],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/${API_VERSION}/cm/room-report-rate`, {
                    params: {
                        filter: params.filter
                    }
                });

                // Validasi response
                const validationResult = RevenueMonthlyResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Revenue monthly response data schema");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Revenue monthly response`, error);
                throw error;
            }
        },
        enabled: !!params.filter && !!params.filter.property_id && !!params.filter.start_date && !!params.filter.end_date,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false
    });
};

export default useRevenueMonthly;